<mat-tab-group>
  <mat-tab label="Vendor Solutions">
    <div class="policy-component" style="margin: 0 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>

        </div>

        <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
          <button mat-raised-button matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                  (click)="inputVendorFile.click()"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Import Responsibilities
          </button>
          <input #inputVendorFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="importVendors($event)"
                 [style.display]="'none'">
          <button mat-raised-button matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                  (click)="inputFile.click()"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Import Solutions
          </button>
          <input #inputFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="import($event, 'Service')"
                 [style.display]="'none'">
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'Vendor', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Vendor
          </button>
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'Service', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Service
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; gap: 40px">
        <div style="width: 100%;">
          <p-table [value]="dictionaryItems" *ngIf="dictionaryItems"
                   dataKey="itemId"
                   #incidentResponseTbl
                   [columns]="cols">
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th [pSortableColumn]="'name'">
                  Solution
                  <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'relatedControls'">
                  Related Controls
                  <p-sortIcon [field]="'relatedControls'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'inheritance'">
                  Responsibility
                  <p-sortIcon [field]="'inheritance'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width:15em"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr *ngIf="item.isFirstTopic && expanded[item.parentId]">
                <td colspan="4">
                  <span style="margin-left: 40px;" class="pi pi-arrow-circle-right"
                        (click)="expanded[item.itemId] = true" *ngIf="!expanded[item.itemId]"></span>
                  <span style="margin-left: 40px;" class="pi pi-arrow-circle-down"
                        (click)="expanded[item.itemId] = false" *ngIf="expanded[item.itemId]"></span>
                  {{ item.securityTopic }}
                </td>
              </tr>
              <tr [pReorderableRow]="i"
                  *ngIf="(item.dictionary != 'Service' || expanded[item.parentId] && expanded[item.topicStart])">
                <td (click)="$event.target.closest('.pi') ? null : edit(item)">
                  <span class="pi pi-arrow-circle-right" (click)="expanded[item.itemId] = true"
                        *ngIf="item.dictionary != 'Service' && !expanded[item.itemId]"></span>
                  <span class="pi pi-arrow-circle-down" (click)="expanded[item.itemId] = false"
                        *ngIf="item.dictionary != 'Service' && expanded[item.itemId]"></span>
                  <span style="display: inline-block; width:80px;"
                        *ngIf="item.dictionary == 'Service'"></span>{{ item.name }}
                </td>
                <td (click)="edit(item)">{{ item.dictionary === 'Service' ? item.relatedControls : '' }}</td>
                <td (click)="edit(item)">{{ item.inheritance }}</td>
                <td style="width: 5em;">
                  <i class="pi pi-pencil" (click)="edit(item)"></i>
                  <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Incident Response'"
                     [popoverMessage]="item.dictionary == 'Vendor' ? 'All services within this vendor will be deleted as well. Are you sure?' : 'You are going to delete this service. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                     (confirm)="dropDictionaryItem(item)"></i>
                </td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Implementation Control Statements" *ngIf="isImplementationControlStatementsVisible">
    <implementation-control-statement-component></implementation-control-statement-component>
  </mat-tab>
  <mat-tab label="Plans of Action">
    <actionItemTemplate-component></actionItemTemplate-component>
  </mat-tab>
  <mat-tab label="Recommended Solutions">
    <recommended-solutions></recommended-solutions>
  </mat-tab>
  <mat-tab label="Reference Resources">
    <reference-resources></reference-resources>
  </mat-tab>
  <mat-tab label="Topics">
    <div class="policy-component" style="margin: 0 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>

        </div>

        <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
          <input #inputFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="import($event, 'Topic')"
                 [style.display]="'none'">
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'Topic', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Topic
          </button>
          <button mat-raised-button
                  (click)="ensureDefaultItems()"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Restore Default List
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; gap: 40px">
        <div style="width: 100%;">
          <p-table [value]="topicDictionaryItems" *ngIf="topicDictionaryItems"
                   dataKey="itemId"
                   #incidentResponseTbl
                   [columns]="topicCols">
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th [pSortableColumn]="'name'">
                  Topic
                  <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width:15em"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td (click)="$event.target.closest('.pi') ? null : edit(item)">
                  {{ item.name }}
                </td>
                <td style="width: 5em;">
                  <i class="pi pi-pencil" (click)="edit(item)"></i>
                  <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Dictionary Item'"
                     [popoverMessage]="item.dictionary == 'Vendor' ? 'All services within this vendor will be deleted as well. Are you sure?' : 'You are going to delete this item. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                     (confirm)="dropDictionaryItem(item)"></i>
                </td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Findings/Notes">
    <div class="policy-component" style="margin: 0 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>

        </div>

        <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
          <input #inputFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="import($event, 'FindingsNotes')"
                 [style.display]="'none'">
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'FindingsNotes', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Findings/Notes
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; gap: 40px">
        <div style="width: 100%;">
          <p-table [value]="findingsNotesDictionaryItems" *ngIf="topicDictionaryItems"
                   dataKey="itemId"
                   #incidentResponseTbl
                   [columns]="topicCols">
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th [pSortableColumn]="'name'">Findings/Notes
                  <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width:15em"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td (click)="$event.target.closest('.pi') ? null : edit(item)">
                  {{ item.name }}
                </td>
                <td style="width: 5em;">
                  <i class="pi pi-pencil" (click)="edit(item)"></i>
                  <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Dictionary Item'"
                     [popoverMessage]="item.dictionary == 'Vendor' ? 'All services within this vendor will be deleted as well. Are you sure?' : 'You are going to delete this item. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                     (confirm)="dropDictionaryItem(item)"></i></td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Recommendations">
    <div class="policy-component" style="margin: 0 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>

        </div>

        <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
          <input #inputFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="import($event, 'Recommendations')"
                 [style.display]="'none'">
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'Recommendations', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Recommendations
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; gap: 40px">
        <div style="width: 100%;">
          <p-table [value]="recommendationsDictionaryItems" *ngIf="topicDictionaryItems"
                   dataKey="itemId"
                   #incidentResponseTbl
                   [columns]="topicCols">
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th [pSortableColumn]="'name'">Recommendations
                  <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width:15em"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td (click)="$event.target.closest('.pi') ? null : edit(item)">
                  {{ item.name }}
                </td>
                <td style="width: 5em;">
                  <i class="pi pi-pencil" (click)="edit(item)"></i>
                  <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Dictionary Item'"
                     [popoverMessage]="item.dictionary == 'Vendor' ? 'All services within this vendor will be deleted as well. Are you sure?' : 'You are going to delete this item. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                     (confirm)="dropDictionaryItem(item)"></i></td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Policy Content">
    <div class="policy-component" style="margin: 0 20px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>

        </div>

        <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
          <input #inputFile
                 type="file"
                 accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                 (change)="import($event, 'PolicyContent')"
                 [style.display]="'none'">
          <button mat-raised-button
                  (click)="edit({itemId: 0, name: '', parentId: null, dictionary: 'PolicyContent', details: ''})"
                  style="border-radius: 6px;margin-right: 10px; "
                  class="button">
            Create Policy Content
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; gap: 40px">
        <div style="width: 100%;">
          <p-table [value]="policyContentItems" *ngIf="policyContentItems"
                   dataKey="itemId"
                   #incidentResponseTbl
                   [columns]="policyContentCols">
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th [pSortableColumn]="'name'">
                  Topic
                  <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'relatedControls'">
                  Name
                  <p-sortIcon [field]="'relatedControls'" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width:15em"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
              <tr class="ui-widget-header"
                  *ngIf="rowGroupMetadata && rowGroupMetadata[item.securityTopic].index === rowIndex">
                <td colspan="3">
                  <a href="#" [pRowToggler]="item">
                    <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{item.securityTopic}}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
              <tr>
                <td (click)="edit(item)">
                  {{ item.securityTopic }}
                </td>
                <td (click)="edit(item)">
                  {{ item.name }}
                </td>
                <td style="width: 5em;">
                  <i class="pi pi-pencil" (click)="edit(item)"></i>
                  <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Policy Content'"
                     [popoverMessage]="'You are going to delete this policy content. Are you sure?'"
                     [appendToBody]="true"
                     [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                     (confirm)="dropDictionaryItem(item)"></i>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
